import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ArrowRightIcon } from 'lucide-react';
const treatments = ['Botox Facial', 'Vampire Facial', 'HydroPOWER Facial'];
export function CTCombine() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px]" data-id="element-755">
      <div className="max-w-[1000px] mx-auto px-6 lg:px-8" data-id="element-756">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-757">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-758">
            COMBINE TREATMENTS FOR AN ADDED GLOW
          </h2>

          <div className="space-y-4 text-white text-[17px] leading-[1.7] font-body mb-10 max-w-[800px]" data-id="element-759">
            <p data-id="element-760">
              Want to make the most out of your time? Treat yourself to any Be
              CLINICAL facial or other aesthetic treatment at the same
              appointment!
            </p>
            <p data-id="element-761">
              We offer facials like Botox Facial, Vampire Facial (Microneedling
              &amp; PRP) and HydroPOWER Facial, just to name a few. Cheers to
              you for great time management!
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 w-full mb-10" data-id="element-762">
            {treatments.map((treatment, index) => <a key={index} href="#" className="bg-white px-9 py-6 shadow-lg flex items-center justify-between hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group" data-id="element-763">
                <span className="text-black text-lg font-bold font-[Poppins,_sans-serif]" data-id="element-764">
                  {treatment}
                </span>
                <ArrowRightIcon size={18} className="text-[#FF1493] group-hover:translate-x-1 transition-transform duration-300" data-id="element-765" />
              </a>)}
          </div>

          <p className="font-serif italic text-white text-2xl lg:text-[28px]" data-id="element-766">
            Treat yourself!
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}